module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-ultralight-webfont-b8e126aefe6cc12924269bab1dc9cd5c.woff";